/**
 * Feature Flags
 * -------------------------------------------------------------
 * Central place to toggle UI sections without redeploying logic.
 * Flip a boolean to true and the corresponding section will render.
 *
 * Activation steps for "Clients & Partners":
 *   1. Set SHOW_CLIENTS_PARTNERS: true below.
 *   2. Open src/components/ClientsPartnersSection.jsx and fill the LOGOS array.
 *   3. Save & redeploy.
 * -------------------------------------------------------------
 */

export const FEATURES = {
  // Set to true once approved client/partner logos are ready.
  SHOW_CLIENTS_PARTNERS: false,
  // Set to true once the 3 remaining professional programs (Leadership, Quality, ToT) have full detail pages.
  SHOW_UPCOMING_PROGRAMS: false,
};
